import interpolate from './utilities/interpolateLabelmap';

export { interpolate };
